export default "__VITE_ASSET__CjD4Q05R__"